{
  "lang": "nl",
  "theme": "rijks-ccv",
  "plugins": [
    "Dialogue",
    "a11y-describedby",
    "a11y-user-detect",
    "alignments-mest",
    "auto-scroll",
    "bb-xarea",
    "custom-radios",
    "end-grids",
    "end-tools",
    "has-no-next-meta",
    "headings",
    "history",
    "info-inline",
    "jquery.xarea",
    "jumplist-prefill",
    "log-url",
    "markdown-it",
    "markdown-it-converter",
    "md-labels",
    "metadata-change-navtext",
    "metaprogress",
    "mis-click-count",
    "no-login",
    "no-models",
    "no-settings",
    "nonce-metatag",
    "noscript",
    "nta:collapsing-grid",
    "nta:dynamic-menu-items",
    "nta:mopinion",
    "nta:path-to-modelname",
    "nta:piwik-nonce",
    "nta:proxymap",
    "nta:rijksoverheidshuisstijlfonts",
    "questionlabelgroup-ng",
    "rijks-ncsc:footer",
    "wrap-table",
    "xsl-to-pdf"
  ],
  "overrideinloghtml": "ccv.html",
  "arbitrary": {
    "core": {
      "scrollToSelectedGroup": false,
      "jumplist": {
        "type": "ol"
      }
    },
    "piwik": {
      "fallback": {
        "code": "9523ffd3-87c5-41bb-9f98-8278d8f79be2",
        "endpoint": "//statistiek.rijksoverheid.nl/containers/"
      }
    },
    "mopinion": {
        "pastease.js": "https://survey-deploy.platformrijksoverheid.nl/js/pastease.js",
       "risicoklasseindeling_digitaleveiligheid": {
        "id": "Dyd2yvA2XWPnhhP5QEC52MBtoSxj9PjFNYzDapFf"
      }
    },
    "proxymap": {
      "check-je-risicoklasse": {
        "modelname": "risicoklasseindeling_digitaleveiligheid"
      },
      "check-je-risicoklasse-indeling": {
        "modelname": "risicoklasseindeling_digitaleveiligheid"
      }
    },
    "noscript": {
      "linkstext": "Deze online tool vereist JavaScript. Volg, om de regelhulp op een browser zonder JavaScript te doen, een van de volgende links.",
      "links": [
        {
          "url": "open?modelname=risicoklasseindeling_digitaleveiligheid",
          "description": "Risicoklasseindeling Digitaleveiligheid"
        }
      ]
    },
    "end-tools": {
      "block": [
        "email"
      ]
    },
    "history": {
      "keepParams": [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_content",
        "utm_uid"
      ]
    }
  },
  "template": {
    "title": "Risicoklassenindeling Digitale Veiligheid",
    "seo": {
      "description": "Check de risicoklasse van je onderneming in 11 vragen en weet welke maatregelen je moet nemen om de veiligheid te verhogen.",
      "canonical": "https://tools.ncsc.nl/check-je-risicoklasse/"
    },
    "logo-link": "https://www.ncsc.nl",
    "auto-scroll": {
      "offset": "-60"
    },
    "readonly-prop": "disabled"
  },
  "legacy": false
}
